module.exports = __webpack_public_path__ + "static/media/maplaria-logo.16f3ac34.png";